// extracted by mini-css-extract-plugin
export var text = "_6h-0";